import React from "react";

import styles from "./FieldsetGroup.module.scss";

interface FieldsetGroupProps {
    // The legend for the fieldset group.
    legend: string;

    // The children to render inside the fieldset.
    children: React.ReactNode;

    // Optional class name for the fieldset element.
    fieldSetClassName?: string;

    // Optional class name for the legend element.
    legendClassName?: string;
}

/**
 * A component that groups form fields with a legend.
 * @param props The properties for the fieldset group.
 */
function FieldsetGroup(props: Readonly<FieldsetGroupProps>): JSX.Element {
    const { legend, children, fieldSetClassName, legendClassName } = props;

    return (
        <fieldset className={fieldSetClassName}>
            <legend className={`${styles.fieldsetLegend} ${legendClassName ?? ""}`}>{legend}</legend>
            {children}
        </fieldset>
    );
}

export default FieldsetGroup;
